"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var BaseTransform_1 = require("./BaseTransform");
var Transform_1 = require("./Transform");
var Query_1 = require("../Query");
var MapTransform = /** @class */ (function (_super) {
    __extends(MapTransform, _super);
    function MapTransform() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.applyTransforms = function (value, transforms, queryOptions, executionOptions) {
            if (transforms) {
                for (var _i = 0, transforms_1 = transforms; _i < transforms_1.length; _i++) {
                    var transformOptions = transforms_1[_i];
                    var transform = new Transform_1.Transform(transformOptions, _this.translationHelper, _this.callStackLevel);
                    value = transform.execute(value, queryOptions, __assign(__assign({}, executionOptions), { responseContext: value }));
                }
            }
            return value;
        };
        return _this;
    }
    MapTransform.prototype.execute = function (queryResponse, queryOptions, executionOptions) {
        var _this = this;
        var response = [];
        var _a = this.options.mapTransformOptions, mapTransformOptions = _a === void 0 ? {} : _a;
        var transforms = mapTransformOptions.transforms, entity = mapTransformOptions.entity;
        if (Array.isArray(queryResponse) && transforms && transforms.length > 0) {
            var context_1 = Query_1.Query.getContext(executionOptions, queryOptions);
            var contextConfiguration = Query_1.Query.getContextConfiguration(executionOptions, queryOptions);
            var queryId_1 = queryOptions.queryId;
            var entityConfiguration_1;
            var linkedEntities_1;
            if (contextConfiguration && contextConfiguration.entities) {
                entityConfiguration_1 = contextConfiguration.entities.find(function (config) { return config.id === queryId_1; });
                linkedEntities_1 = entityConfiguration_1 && entityConfiguration_1.linkedEntities;
            }
            queryResponse.forEach(function (queryResponseItem) {
                var _a, _b;
                var subExecutionOptions = __assign(__assign({}, executionOptions), { context: context_1 });
                if (entity && entity.load && queryResponseItem) {
                    if (linkedEntities_1) {
                        // Get the entityMap and entitiesById based on the base entity
                        var _c = context_1.entities[queryId_1], entityMap = _c.entityMap, entitiesById = _c.entitiesById;
                        var queryContextEntityMap = entityMap.get(queryResponseItem.entityId);
                        // Add this entity data to the entitiesById map
                        entitiesById.set(queryResponseItem.entityId, queryResponseItem);
                        // Add this entityId to the entityMap
                        var entityId = new Set([queryResponseItem.entityId]);
                        var overridingEntityMap = __assign(__assign({}, queryContextEntityMap), (_a = {}, _a[entityConfiguration_1.id] = entityId, _a));
                        subExecutionOptions.context = {
                            entitiesById: entitiesById,
                            entityMap: overridingEntityMap,
                        };
                    }
                    else {
                        var entityType = entity.entityType || queryResponseItem['type'];
                        var baseContext = subExecutionOptions.context || {};
                        var baseContextEntityByType = baseContext && baseContext.entityByType || {};
                        subExecutionOptions.context = __assign(__assign({}, baseContext), { entityByType: __assign(__assign({}, baseContextEntityByType), (_b = {}, _b[entityType] = queryResponseItem, _b)) });
                    }
                }
                var finalValue = _this.applyTransforms(queryResponseItem, transforms, queryOptions, subExecutionOptions);
                response.push(finalValue);
            });
        }
        return response;
    };
    return MapTransform;
}(BaseTransform_1.BaseTransform));
exports.MapTransform = MapTransform;
//# sourceMappingURL=MapTransform.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@kurtosys/ksys-app-template/dist/query/transform/MapTransform.js
// module id = 323
// module chunks = 1